export default {
    dependencies: [
        '$element',
        'finnboxservice',
        'radio',
        'trackingservice',
        'objectstore',
    ],
    callable(element, service, radio, trackingService, objectstore) {
        const replyButton = element.querySelector('[data-reply-submit]');
        const textarea = element.querySelector('[data-reply-message]');
        const progress = element.querySelector('[data-reply-progress]');
        const error = element.querySelector('[data-reply-error]');
        let cursor = 0;
        const conversationId = element.getAttribute('data-conversation-id');
        const prefix = 'finnbox_reply_';
        const replyStoreKey = prefix + conversationId;

        init();

        function init() {
            setupEvents();
            restoreReply();
        }

        function restoreReply() {
            textarea.value = objectstore.get(replyStoreKey) || '';
            updateButton();
            updateTextarea();
        }

        function setupEvents() {
            replyButton.addEventListener('click', handleReplyButtonClick);
            textarea.addEventListener('focus', handleTextareaFocus);
            textarea.addEventListener('blur', handleTextareaBlur);
            textarea.addEventListener('input', handleTextareaInput);
        }

        function handleReplyButtonClick(event) {
            event.preventDefault();
            const data = getReplyData();
            if (isValidReply(data.messageText)) {
                sendReply(data);
            }
        }

        function handleTextareaFocus() {
            trackingService.deprecatedTrackEvent('finnbox_reply_start');
            textarea.setSelectionRange(cursor, cursor);
            radio('finnbox-reply-focus').broadcast();
        }

        function handleTextareaBlur() {
            cursor = textarea.selectionEnd;
        }

        function handleTextareaInput() {
            updateButton();
            updateTextarea();
            objectstore.put(replyStoreKey, textarea.value);
        }

        function sendReply(data) {
            trackingService.deprecatedTrackEvent('finnbox_reply_send');
            showProgress();
            service.sendReply(data, callback);
            function callback(result) {
                hideProgress();
                if (result.success) {
                    radio('finnbox-reply-success').broadcast(data.messageText);
                    textarea.value = '';
                    textarea.rows = 1;
                    replyButton.disabled = true;
                    objectstore.del(replyStoreKey);
                } else {
                    error.classList.remove('hidden');
                    radio('finnbox-reply-failure').broadcast();
                }
            }
        }

        function showProgress() {
            error.classList.add('hidden');
            progress.classList.remove('hidden');
            replyButton.classList.add('hidden');
            textarea.classList.add('hidden');
        }

        function hideProgress() {
            progress.classList.add('hidden');
            replyButton.classList.remove('hidden');
            textarea.classList.remove('hidden');
        }

        function getReplyData() {
            const data = {};
            data.inReplyTo = element.getAttribute('data-in-reply-to');
            data.messageText = textarea.value;
            return data;
        }

        function isValidReply(messageText) {
            return messageText.trim() !== '';
        }

        function setMessage(message) {
            textarea.value = message;
            handleTextareaInput();
        }

        function updateButton() {
            replyButton.disabled = !isValidReply(getReplyData().messageText);
        }

        function updateTextarea() {
            const oldRowCount = textarea.rows;
            while (
                textarea.scrollHeight > textarea.offsetHeight &&
                textarea.rows < 4
            ) {
                textarea.rows += 1;
            }
            if (textarea.rows > oldRowCount) {
                radio('finnbox-reply-grow').broadcast();
            }
        }

        return {
            setMessage,
            handleTextareaInput,
        };
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxReply.js